import React from "react";
import LandingPage from "../components/LandingPage/LandingPage";

const LandingPageWrapper = () => {
  return <LandingPage />;
};

export default LandingPageWrapper;
